import { Marker } from "@react-google-maps/api";
import React, { useContext } from "react";
import { getAvailability, getEsHs } from "../../utility/api-utilities";
import { AppContext } from "../school-search-app";
import { renderToString } from 'react-dom/server'
import SchoolMarkerSvg, { ICON_C, ICON_L, ICON_SCHOOL } from "../info/school-marker-svg";
import { theme } from "../../utility/styles";
import { PAGE_MODE, SCHOOL_TYPE } from '../../interfaces'

type SchoolMapMarkerProps = {
    school: any;
    feature: any; // geojson feature, maybe type?
    selectSchool: (any) => void; // set the map selected school
    checked: boolean; // 
}



function SchoolMapMarker({ school, feature, selectSchool, checked = false }) {
    const appContext = useContext(AppContext)
    function getMapIcon(school): string | google.maps.Icon | google.maps.Symbol {
        //set marker color and icon
        let icon = null;
        let markerColor = 'blue';
        if (appContext.mode == PAGE_MODE.GOCPS) {
            markerColor = getEsHs(school) === 'hs' ? theme.cpsHsColor : theme.cpsEsColor;
            if (school?._tag == 'Neighborhood School') {
                icon = ICON_SCHOOL
            }
        }
        else if (appContext.mode == PAGE_MODE.SUMMER_PROGRAMM) {
            markerColor = theme.progColor;
        }
        else if (appContext.mode == PAGE_MODE.PREK) {
            markerColor = school.type == SCHOOL_TYPE.CEL ? theme.prekCelColor : theme.prekCpsColor;
        }

        // might need to optimize
        let dot;
        if (appContext.mode != PAGE_MODE.SUMMER_PROGRAMM) {
            dot = theme.availability[getAvailability(school._epi.availability).toLowerCase()] ?? null
        }

        return {
            url: `data:image/svg+xml;charset=UTF-8;base64,${btoa(renderToString(
                <SchoolMarkerSvg color={markerColor} checked={checked} icon={icon} dot={dot} />
            ))}`,
            scaledSize: new google.maps.Size(32, 36),
        }
    }

    return <Marker
        key={feature.id}
        position={{ lat: feature.geometry.coordinates[1], lng: feature.geometry.coordinates[0] }}
        icon={getMapIcon(school)}
        onClick={() => selectSchool(school, { lat: feature.geometry.coordinates[1], lng: feature.geometry.coordinates[0] })}
    />
}

export default SchoolMapMarker;